import React from 'react'
import { RegionContainer } from './styles/Utility.styles'
import ProductGridItem from '../components/ContentBlocks/ProductGridItem'
import * as Styled from './styles/RelatedProducts.styles'

const RelatedProducts = ({ products }) => {
  // Return nothing if no related products exist
  if (!products || !products.length) return null

  return (
    <>
      <Styled.HeaderContainer>
        <Styled.RelatedProductsCircleAccent />
        <Styled.RelatedProductsSectionHeader>
          Related Products
        </Styled.RelatedProductsSectionHeader>
      </Styled.HeaderContainer>
      <Styled.RelatedProductsGridContainer>
        {products.map((product, idx) => (
          <ProductGridItem key={product.id} item={product} grayBackground />
        ))}
      </Styled.RelatedProductsGridContainer>
    </>
  )
}

export default RelatedProducts
